// Shared Tailwind `prose` classes for rendering blog article HTML.
// Used by both the public BlogDetail page and the admin editor preview so the
// "preview before publishing" looks exactly like what gets published.
//
// Notes on responsiveness:
// - `prose-sm sm:prose-base lg:prose-lg` keeps type readable (not oversized) on
//   phones and scales up on larger screens.
// - `break-words` + `[overflow-wrap:anywhere]` stop long URLs/words from forcing
//   horizontal overflow (the main cause of content getting cut off on mobile).
// - images are capped to the container width; `<pre>` and tables scroll instead
//   of overflowing the page. Inline `style="width:.."` on an image still wins
//   (so in-content image resizing is respected) because it beats these classes.
export const BLOG_PROSE_CLASS = `prose prose-sm sm:prose-base lg:prose-lg max-w-none w-full min-w-0 break-words [overflow-wrap:anywhere]
  prose-headings:text-[#252F4F] prose-headings:break-words
  prose-h1:text-3xl sm:prose-h1:text-4xl prose-h1:font-bold prose-h1:mb-6
  prose-h2:text-2xl sm:prose-h2:text-3xl prose-h2:font-bold prose-h2:mt-8 prose-h2:mb-4
  prose-h3:text-xl sm:prose-h3:text-2xl prose-h3:font-semibold prose-h3:mt-6 prose-h3:mb-3
  prose-p:text-gray-700 prose-p:leading-relaxed prose-p:mb-4
  prose-a:text-[#98C454] prose-a:no-underline prose-a:break-words hover:prose-a:underline
  prose-strong:text-[#252F4F] prose-strong:font-semibold
  prose-ul:list-disc prose-ul:ml-6 prose-ul:mb-4
  prose-ol:list-decimal prose-ol:ml-6 prose-ol:mb-4
  prose-li:text-gray-700 prose-li:mb-2
  prose-blockquote:border-l-4 prose-blockquote:border-[#98C454] prose-blockquote:pl-4 prose-blockquote:italic prose-blockquote:my-6
  prose-img:rounded-lg prose-img:shadow-md prose-img:my-6 prose-img:max-w-full prose-img:h-auto prose-img:mx-auto
  prose-code:text-sm prose-code:bg-gray-100 prose-code:px-1 prose-code:py-0.5 prose-code:rounded prose-code:break-words
  prose-pre:bg-gray-900 prose-pre:text-gray-100 prose-pre:rounded-lg prose-pre:p-4 prose-pre:overflow-x-auto prose-pre:max-w-full
  prose-table:block prose-table:w-full prose-table:overflow-x-auto`;
